import React from "react";
import AboutUs from "../components/AboutUs";
import CertificationsSection from "../components/Certifications";
import ClientCarousel from "../components/ClientCarousel";
import ContactSection from "../components/ContactUs";
import LandingImage from "../components/LandingImage";
import PolybagsSection from "../components/PolyBags";
import Solutions from "../components/Solutions";
import SustainabilitySection from "../components/Sustainability";

export default function Home() {
  return (
    <>
      <LandingImage />
      <ClientCarousel />
      <PolybagsSection />
      <CertificationsSection />
      <AboutUs />
      <Solutions />
      <SustainabilitySection />
      <ContactSection />
      {/* <VideoSection /> */}
    </>
  );
}